import classNames from 'classnames'
import { CustomColorsRef, IconSizes } from 'types/general'

import IconRender from '../IconRender'

interface LoadingProps {
  fullscreen?: boolean
  message?: string
  className?: string
}

const Loading = ({ fullscreen, message, className }: LoadingProps) => (
  <div
    className={`flex justify-center items-center ${
      fullscreen ? 'fixed inset-0 bg-gray-500 bg-opacity-50 z-50' : 'relative'
    }`}
  >
    <div
      className={classNames(
        'flex flex-col items-center justify-center',
        {
          'w-full h-full': fullscreen,
          'p-4 rounded-lg': !fullscreen,
        },
        className
      )}
    >
      <IconRender
        icon="regular-spinner-third"
        size={IconSizes.XL}
        color={CustomColorsRef.Primary}
        className="animate-spin"
      />
      {message && <p className="mt-4 text-lg text-center">{message}</p>}
    </div>
  </div>
)

export default Loading
